import { Route, Navigate } from 'react-router'
import { RoutesWithNotFound } from 'entities/ExportRouters/ui/RoutesWithNotFound'
import { AssignNumberStepsLayout } from 'pages/settings/pages/inboxes/pages/id/pages/numbers/pages/AssignNumber/layout/AssignNumberStepsLayout'
import { AddSalesmsgNumbers } from 'pages/settings/pages/inboxes/pages/id/pages/numbers/pages/AssignNumber/ui/AddSalesmsgNumbers/AddSalesmsgNumbers'
import { Payment } from 'pages/settings/pages/inboxes/pages/id/pages/numbers/pages/AssignNumber/ui/Payment/Payment'
import { NewInboxRoutes } from 'pages/settings/pages/inboxes/route/type'
import { AssignNumberAccessLayout } from 'pages/settings/pages/inboxes/pages/id/pages/numbers/pages/AssignNumber/layout/AssignNumberAccessLayout'

export const AssignNumberStepsRouter = () => {
  return (
    <RoutesWithNotFound>
      <Route element={<AssignNumberAccessLayout />}>
        <Route element={<AssignNumberStepsLayout />}>
          <Route index element={<Navigate to={NewInboxRoutes.addSalesmsgNumbers} replace />} />
          <Route path={NewInboxRoutes.addSalesmsgNumbers} element={<AddSalesmsgNumbers />} />
          <Route path={NewInboxRoutes.payment} element={<Payment />} />
        </Route>
      </Route>
    </RoutesWithNotFound>
  )
}
